package com.appsyde.shared.presentation.style.style

 import com.appsyde.shared.presentation.style.token.AppStylesTokens
import org.jetbrains.compose.web.css.*

object AppStylesTickets : StyleSheet() {

    val body by style {
        minWidth(0.px)
        property("font-family", AppStylesTokens.FONT_FAMILY)
        backgroundColor(Color(AppStylesTokens.CARD_BODY_BG))
    }

    // ---------- Header (aligné Respond / ticketCardHeader) ----------
    val headerLeft by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
        minWidth(0.px)
    }

    val headerTitleCol by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(2.px)
        minWidth(0.px)
    }

    val headerKicker by style {
        fontSize(11.px)
        fontWeight(650)
        color(Color("rgba(102,96,230,0.72)"))
        property("letter-spacing", "-0.004em")
    }

    val headerTitle by style {
        fontSize(17.px)
        fontWeight(600)
        color(Color("rgba(15,23,42,0.82)"))
        property("letter-spacing", "-0.012em")
        lineHeight("1.25")
    }

    val headerSub by style {
        marginTop(2.px)
        fontSize(12.px)
        fontWeight(500)
        color(Color(AppStylesTokens.INK_MUTED))
        property("letter-spacing", "-0.004em")
        minWidth(0.px)
    }

    val headerRight by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(6.px)
        padding(2.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(15,23,42,0.05)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        minWidth(0.px)
    }

    // ---------- Toolbar ----------
    val toolbar by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(12.px)
        minWidth(0.px)
        marginBottom(14.px)
    }

    /** Ligne d’onglets Ticket à voir / Tous */
    val ticketsViewTabsRow by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Row)
        gap(6.px)
        alignItems(AlignItems.Center)
        minWidth(0.px)
    }

    val ticketsViewTab by style {
        padding(6.px, 12.px)
        borderRadius(8.px)
        fontSize(13.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.6)"))
        backgroundColor(Color("transparent"))
        border(1.px, LineStyle.Solid, Color("rgba(0,0,0,0)"))
        property("cursor", "pointer")
        property("transition", "background-color 140ms ease, color 140ms ease, border-color 140ms ease")
        self + hover style {
            color(Color("rgba(15,23,42,0.85)"))
            backgroundColor(Color("rgba(15,23,42,0.04)"))
        }
    }

    val ticketsViewTabActive by style {
        color(Color("rgba(59,70,212,0.92)"))
        backgroundColor(Color("rgba(102,96,230,0.1)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.2)"))
        self + hover style {
            backgroundColor(Color("rgba(102,96,230,0.14)"))
        }
    }

    val searchWrap by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(10.px)
        minWidth(0.px)
        padding(12.px, 14.px)
        borderRadius(AppStylesTokens.RADIUS_PAGE.px)
        backgroundColor(Color(AppStylesTokens.CARD))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        property("box-shadow", AppStylesTokens.SHADOW_TINY)
        property("backdrop-filter", "blur(10px)")
        property("-webkit-backdrop-filter", "blur(10px)")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val searchIcon by style {
        width(28.px)
        height(28.px)
        borderRadius(12.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        backgroundColor(Color(AppStylesTokens.BRAND_SOFT))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.18)"))
        color(Color(AppStylesTokens.PURPLE))
        fontSize(12.px)
        fontWeight(700)
        flexShrink(0)
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val searchInput by style {
        property("flex", "1 1 0")
        minWidth(0.px)
        fontSize(14.px)
        fontWeight(500)
        color(Color(AppStylesTokens.INK_SOFT))
        backgroundColor(Color("transparent"))
        border(0.px, LineStyle.Solid, Color("transparent"))
        property("outline", "none")
    }

    val searchHint by style {
        padding(6.px, 9.px)
        borderRadius(999.px)
        fontSize(11.5.px)
        fontWeight(700)
        color(Color("rgba(31,42,68,0.55)"))
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.06)"))
        flexShrink(0)
    }

    val filtersWrap by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.FlexStart)
        gap(12.px)
        minWidth(0.px)
    }

    val filterGroup by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(8.px)
        minWidth(0.px)
    }

    val filterLabel by style {
        fontSize(11.5.px)
        fontWeight(750)
        color(Color("rgba(31,42,68,0.55)"))
        property("letter-spacing", "-0.004em")
    }

    val pillsRow by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        gap(6.px)
        alignItems(AlignItems.Center)
        minWidth(0.px)
    }

    /** Pills section (Ouvert/En attente/Fermé) : plus petites, discrètes, informatives */
    val pill by style {
        padding(3.px, 7.px)
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        fontSize(10.5.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK_SOFT))
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        property("cursor", "pointer")
        property("user-select", "none")
        property("transition", AppStylesTokens.TRANSITION_FAST)
        property("transform", "translateY(0px)")
    }

    val pillActive by style {
        backgroundColor(Color("rgba(102,96,230,0.08)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.14)"))
        color(Color("rgba(59,70,212,0.88)"))
    }

    /** Ouvert — neutre (même famille que En attente/Fermé) */
    val pillOuvert by style {
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        color(Color("rgba(15,23,42,0.68)"))
    }

    val pillNeutral by style {
        color(Color(AppStylesTokens.INK_SOFT))
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
    }

    /** En attente — teinte douce */
    val pillWait by style {
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.09)"))
        color(Color("rgba(15,23,42,0.68)"))
    }

    val pillClosed by style {
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        color(Color(AppStylesTokens.INK_MUTED))
    }

    // ---------- Pills section header (À traiter / En attente / Terminés) : plus grandes, cliquables, avec indicateur ----------
    /** Base pour les 3 pills du header (Ouvert, En attente, Fermé) — plus grandes que les pills des rows */
    val pillSectionHeader by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        padding(6.px, 10.px)
        borderRadius(10.px)
        fontSize(12.5.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.56)"))
        backgroundColor(Color("rgba(0,0,0,0)"))
        border(1.px, LineStyle.Solid, Color("rgba(0,0,0,0)"))
        property("appearance", "none")
        property("cursor", "pointer")
        property("user-select", "none")
        property("transition", "background-color 160ms ease, color 160ms ease, box-shadow 160ms ease")
    }

    /** Pill inactive (section non expandée) : poids réduit */
    val pillSectionHeaderInactive by style {
        fontWeight(500)
        color(Color("rgba(15,23,42,0.52)"))
    }

    /** Pill active (section expandée) : même style pour les trois — force réduite */
    val pillSectionHeaderActive by style {
        fontWeight(500)
        backgroundColor(Color("#FFFFFF"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        color(Color("rgba(15,23,42,0.78)"))
        property("box-shadow", "0 1px 4px rgba(15,23,42,0.08)")
    }

    /** Point indicateur sur la pill : visible quand la section est expandée */
    val sectionPillDot by style {
        width(6.px)
        height(6.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(15,23,42,0.2)"))
        flexShrink(0)
        opacity(0.35)
        property("transition", "opacity 160ms ease, background-color 160ms ease")
    }

    val sectionPillDotExpanded by style {
        opacity(0.85)
        backgroundColor(Color("rgba(59,70,212,0.58)"))
    }

    val pillUrgent by style {
        backgroundColor(Color("rgba(239, 68, 68, 0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(239, 68, 68, 0.12)"))
        color(Color("rgba(185, 28, 28, 0.82)"))
    }

    val pillHigh by style {
        backgroundColor(Color("rgba(255, 196, 87, 0.08)"))
        border(1.px, LineStyle.Solid, Color("rgba(255, 196, 87, 0.16)"))
        color(Color("rgba(15,23,42,0.78)"))
    }

    val selectPill by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        padding(6.px, 10.px)
        borderRadius(999.px)
        fontSize(12.2.px)
        fontWeight(750)
        color(Color(AppStylesTokens.INK_SOFT))
        backgroundColor(rgba(255, 255, 255, 0.78))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        property("cursor", "pointer")
        property("user-select", "none")
        property("transition", "transform 140ms ease, border-color 140ms ease, background 140ms ease")
        property("transform", "translateY(0px)")
    }

    val chev by style {
        fontSize(12.px)
        color(Color("rgba(31,42,68,0.50)"))
        property("transform", "translateY(1px)")
        property("transition", "transform 140ms ease, opacity 140ms ease")
    }

    // ---------- Section headers (alignés panelKicker / panelTitle Respond) ----------
    val sectionHeader by style {
        marginTop(20.px)
        marginBottom(12.px)
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.FlexEnd)
        minWidth(0.px)
    }

    /** Header row cliquable pour expand/collapse (toute la ligne) */
    val sectionHeaderClickable by style {
        property("cursor", "pointer")
        property("transition", "opacity 140ms ease")
        self + hover style {
            opacity(0.88)
        }
    }

    val sectionTitleCol by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(2.px)
        minWidth(0.px)
    }

    val sectionTitleRow by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        minWidth(0.px)
    }

    val sectionTitleDot by style {
        width(8.px)
        height(8.px)
        borderRadius(50.percent)
        flexShrink(0)
        property("box-shadow", "none")
    }

    val sectionTitleDotOpen by style {
        backgroundColor(Color("rgba(59,70,212,0.62)"))
    }

    val sectionTitleDotWaiting by style {
        backgroundColor(Color("rgba(245,158,11,0.72)"))
    }

    val sectionTitleDotClosed by style {
        backgroundColor(Color("rgba(100,116,139,0.72)"))
    }

    val sectionTitle by style {
        fontSize(13.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK_SOFT))
        property("letter-spacing", "-0.012em")
    }

    val sectionSub by style {
        fontSize(12.px)
        fontWeight(400)
        color(Color(AppStylesTokens.INK_MUTED))
        property("letter-spacing", "-0.004em")
    }

    val sectionRightMeta by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
    }

    /** Indicateur chevron (▾/▴) dans le header — toute la ligne est cliquable */
    val sectionChevron by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        color(Color(AppStylesTokens.INK_MUTED))
        fontSize(13.px)
        flexShrink(0)
    }

    val sectionCount by style {
        padding(6.px, 12.px)
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        fontSize(12.px)
        fontWeight(600)
        color(Color(AppStylesTokens.INK_MUTED))
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
    }

    val rowsWrap by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(7.px)
        minWidth(0.px)
    }

    // ---------- Row card ----------
    /** Cartes non sélectionnées = presque blanc (légère différence avec sélectionnée) */
    val rowCard by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Stretch)
        gap(12.px)
        minWidth(0.px)
        padding(8.px, 14.px)
        borderRadius(12.px)
        backgroundColor(Color("#FFFFFF"))
        border(1.px, LineStyle.Solid, Color("rgba(0,0,0,0)"))
        property("box-shadow", "0 2px 8px rgba(15,23,42,0.04)")
        property("cursor", "pointer")
        property("transition", "background-color 180ms ease, box-shadow 180ms ease, border-color 180ms ease")
        property("transform", "translateY(0px)")
        self + hover style {
            backgroundColor(Color("#FFFFFF"))
            property("box-shadow", "0 4px 14px rgba(15,23,42,0.06)")
            property("transform", "translateY(-1px)")
        }
    }

    val rowCardClosed by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Stretch)
        gap(12.px)
        minWidth(0.px)
        padding(8.px, 14.px)
        borderRadius(12.px)
        backgroundColor(Color("#FFFFFF"))
        border(1.px, LineStyle.Solid, Color("rgba(0,0,0,0)"))
        property("box-shadow", "0 2px 8px rgba(15,23,42,0.035)")
        opacity(0.96)
        property("cursor", "pointer")
        property("transition", "background-color 160ms ease, box-shadow 160ms ease")
    }

    /** Ligne assignée à moi : fond léger teinte brand, un peu plus marqué qu’avant */
    /** Ligne assignée à moi : bordure latérale gauche brand. */
    /** Carte sélectionnée : bordure + ombre + léger décalage, sans forcer le fond (conserve mine/other/default) */
    val rowCardSelected by style {
        border(1.px, LineStyle.Solid, Color("rgba(59,70,212,0.16)"))
        property("box-shadow", "0 4px 12px rgba(15,23,42,0.08)")
        property("transform", "translateX(4px)")
        property("transition", "box-shadow 180ms ease, border-color 180ms ease, transform 180ms ease")
        self + hover style {
            property("transform", "translateX(4px) translateY(-1px)")
        }
    }

    val rowLeft by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        alignItems(AlignItems.Center)
        gap(10.px)
        flexShrink(0)
        width(18.px)
        paddingTop(0.px)
    }

    val statusDot by style {
        width(10.px)
        height(10.px)
        borderRadius(50.percent)
        backgroundColor(Color("#FFFFFF"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.14)"))
        property("box-shadow", "none")
        property("transition", "transform 160ms ease, box-shadow 160ms ease, opacity 160ms ease, background-color 160ms ease, border-color 160ms ease")
        property("transform", "translateY(0px)")
    }

    val statusDotInline by style {
        flexShrink(0)
        property("transform", "translateY(1px)")
    }

    /** Point Ouvert — discret (évite trop de couleur verte) */
    val statusDotOpen by style {
        backgroundColor(Color("rgba(59,70,212,0.5)"))
        property("box-shadow", "0 0 0 4px rgba(59,70,212,0.08)")
    }

    val statusDotWaiting by style {
        backgroundColor(Color("rgba(245,158,11,0.65)"))
        property("box-shadow", "0 0 0 4px rgba(245,158,11,0.12)")
    }

    val statusDotClosed by style {
        backgroundColor(Color("rgba(15,23,42,0.22)"))
        property("box-shadow", "0 0 0 4px rgba(15,23,42,0.06)")
    }

    val unreadDot by style {
        width(6.px)
        height(6.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(102,96,230,0.62)"))
        property("box-shadow", "0 0 0 4px rgba(102,96,230,0.10)")
        property("transition", "opacity 160ms ease, transform 160ms ease")
        property("transform", "translateY(0px)")
    }

    val unreadDotGhost by style {
        width(6.px)
        height(6.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(0,0,0,0)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        opacity(0.35)
        property("transition", "opacity 160ms ease, transform 160ms ease")
        property("transform", "translateY(0px)")
    }

    val rowMain by style {
        display(DisplayStyle.Flex)
        flexDirection(FlexDirection.Column)
        gap(4.px)
        minWidth(0.px)
        property("flex", "1 1 0")
    }

    val rowTitleLine by style {
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.SpaceBetween)
        alignItems(AlignItems.FlexStart)
        gap(10.px)
        minWidth(0.px)
    }


    /** Titre row : base commune */
    val rowTitle by style {
        fontSize(14.5.px)
        property("letter-spacing", "-0.012em")
        lineHeight("1.28")
        minWidth(0.px)
        property("flex", "1 1 0")
        property("display", "-webkit-box")
        property("-webkit-box-orient", "vertical")
        property("-webkit-line-clamp", "2")
        overflow("hidden")
    }

    /** Titre row non sélectionné : un peu plus marqué qu’avant, tout en restant distinct du sélectionné */
    val rowTitleUnselected by style {
        fontWeight(500)
        color(Color("rgba(15,23,42,0.82)"))
    }

    /** Titre row sélectionné : plus marqué */
    val rowTitleSelected by style {
        fontWeight(500)
        color(Color("rgba(15,23,42,0.82)"))
    }

    /** 1re partie du titre (ex. "Article manquant") : weight 600 */
    val rowTitlePart1 by style {
        fontWeight(600)
        color(Color("rgba(15,23,42,0.90)"))
    }

    /** Séparateur · entre les parties du titre */
    val rowTitleSep by style {
        fontSize(12.5.px)
        fontWeight(400)
        color(Color("rgba(15,23,42,0.40)"))
        margin(0.px, 3.px)
    }

    /** 2e partie du titre (ex. "Commande #91542", nom produit) : gris clair, taille réduite */
    val rowTitlePart2 by style {
        fontSize(12.5.px)
        fontWeight(500)
        color(Color(AppStylesTokens.INK_MUTED))
    }

    /** 3e partie du titre : gris clair, taille réduite */
    val rowTitlePart3 by style {
        fontSize(12.5.px)
        fontWeight(400)
        color(Color(AppStylesTokens.INK_MUTED))
    }

    val rowActions by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        flexShrink(0)
        opacity(0.0)
        property("transform", "translateY(2px)")
        property("transition", "opacity 140ms ease, transform 140ms ease")
        property("pointer-events", "none")
    }

    val iconButton by style {
        width(32.px)
        height(32.px)
        borderRadius(12.px)
        backgroundColor(Color("rgba(255,255,255,0.70)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        property("box-shadow", "0 10px 22px rgba(15,23,42,0.04), inset 0 1px 0 rgba(255,255,255,0.65)")
        display(DisplayStyle.Flex)
        justifyContent(JustifyContent.Center)
        alignItems(AlignItems.Center)
        fontSize(13.px)
        fontWeight(800)
        color(Color("rgba(31,42,68,0.74)"))
        property("cursor", "pointer")
        property("transition", "transform 140ms ease, box-shadow 140ms ease, border-color 140ms ease, opacity 140ms ease")
        property("transform", "translateY(0px)")
    }

    val rowSubLine by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        minWidth(0.px)
        fontSize(13.0.px)
        fontWeight(650)
        color(Color(AppStylesTokens.INK_MUTED))
        property("letter-spacing", "-0.006em")
    }

    val rowSubLineUnreadWrap by style {
        flexShrink(0)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
    }

    val rowClient by style {
        color(Color("rgba(31,42,68,0.70)"))
        fontWeight(700)
        minWidth(0.px)
        property("white-space", "nowrap")
        overflow("hidden")
        property("text-overflow", "ellipsis")
        property("max-width", "360px")
    }
    val rowClientMuted by style {
        color(Color("#6B7280"))              // gris moyen (plus doux que le titre)
        opacity(0.75)                        // léger retrait visuel
        fontSize(13.px)
        lineHeight("1.4")
        property("white-space", "nowrap")
        property("overflow", "hidden")
        property("text-overflow", "ellipsis")
        maxWidth(260.px)

    }

    val rowSep by style {
        color(Color("rgba(31,42,68,0.35)"))
        fontWeight(800)
    }

    val rowAge by style {
        color(Color("rgba(31,42,68,0.55)"))
        fontWeight(650)
        flexShrink(0)
    }

    val metaLine by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.Center)
        gap(6.px)
        minWidth(0.px)
        paddingTop(2.px)
        property("transition", "opacity 140ms ease")
    }
    val metaPillConfirm by style {
         opacity(0.92)

    }

    /** Meta pills (row) : plus petites, discrètes, informatives, moins saturées */
    val metaPill by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(4.px)
        padding(3.px, 6.px)
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        fontSize(10.5.px)
        fontWeight(600)
        property("letter-spacing", "-0.004em")
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        color(Color(AppStylesTokens.INK_SOFT))
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val metaPillIntent by style {
        backgroundColor(Color("rgba(102,96,230,0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.12)"))
        color(Color("rgba(59,70,212,0.82)"))
    }

    val metaPillNeutral by style {
        backgroundColor(Color("rgba(15,23,42,0.03)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        color(Color(AppStylesTokens.INK_MUTED))
    }

    val metaPillHigh by style {
        backgroundColor(Color("rgba(255, 196, 87, 0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(255, 196, 87, 0.14)"))
        color(Color("rgba(180,83,9,0.82)"))
    }

    val metaPillUrgent by style {
        backgroundColor(Color("rgba(239, 68, 68, 0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(239, 68, 68, 0.12)"))
        color(Color("rgba(185, 28, 28, 0.82)"))
    }

    val metaPillMissing by style {
        backgroundColor(Color("rgba(255, 193, 7, 0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(255, 193, 7, 0.14)"))
        color(Color("rgba(180,83,9,0.82)"))
        fontWeight(600)
    }

    val metaIcon by style {
        fontSize(10.px)
        lineHeight("1")
        opacity(0.92)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        flexShrink(0)
        property("transition", "opacity 140ms ease")
    }

    /** Icône dans badge "Manque" — légèrement plus grande pour visibilité */
    val metaIconMissing by style {
        fontSize(10.5.px)
        lineHeight("1")
        opacity(0.95)
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        flexShrink(0)
    }

    val metaText by style {
        property("white-space", "nowrap")
        lineHeight("1")
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
    }

    // --- Layout for line 1 ---
    val rowTitleLineV2 by style {
        display(DisplayStyle.Flex)
        property("align-items", "center")
        property("justify-content", "space-between")
        gap(16.px)
    }

    val rowTitleLeft by style {
        display(DisplayStyle.Flex)
        property("align-items", "center")
        gap(10.px)
        property("min-width", "0") // allow ellipsis for long titles
        flexGrow(1)
    }

    val rowTitleRight by style {
        display(DisplayStyle.Flex)
        property("align-items", "center")
        gap(10.px)
        flexShrink(0)
    }

    /** Petit badge sur la ligne du titre quand infos manquantes / à confirmer */
    val rowTitleMissingBadge by style {
        flexShrink(0)
        fontSize(9.px)
        fontWeight(600)
        padding(3.px, 5.px)
        borderRadius(6.px)
        backgroundColor(Color("rgba(180,83,9,0.08)"))
        color(Color("rgba(154,70,8,0.82)"))
        property("white-space", "nowrap")
    }

    /** Icône seule "choses à compléter" (📋) : discret, pas de pill */
    val rowTitleMissingIcon by style {
        flexShrink(0)
        fontSize(13.px)
        lineHeight(1.px)
        opacity(0.78)
    }

    // age on right (très discret pour ne pas concurrencer le titre)
    /** Timestamps discrets */
    val rowAgeInline by style {
        fontSize(9.5.px)
        fontWeight(500)
        color(Color("rgba(15,23,42,0.52)"))
        opacity(0.9)
        property("white-space", "nowrap")
    }

    /** Indicateur règles métier (À traiter / depuis…) : discret, ne doit pas l’emporter sur le titre */
    val rowBusinessStatusLabel by style {
        fontSize(10.5.px)
        fontWeight(500)
        property("letter-spacing", "0.15px")
        property("white-space", "nowrap")
    }

    /** Pill (fond) pour les statuts "action" : discrète pour ne pas dominer le titre */
    val rowBusinessStatusPill by style {
        padding(3.px, 6.px)
        borderRadius(6.px)
        property("white-space", "nowrap")
    }

    val rowBusinessStatusTraite by style { color(Color("rgba(107,114,128,0.88)")) }
    /** À traiter (ageDays == 0) : neutre, texte seul */
    val rowBusinessStatusATraiterNeutral by style { color(Color("rgba(55,65,81,0.72)")) }
    /** À traiter depuis X jours : orange atténué pour ne pas dominer le titre */
    val rowBusinessStatusATraiter by style {
        color(Color("rgba(180,83,9,0.82)"))
        backgroundColor(Color("rgba(217,119,6,0.08)"))
    }
    /** À vérifier : amber atténué */
    val rowBusinessStatusAVerifier by style {
        color(Color("rgba(161,98,7,0.78)"))
        backgroundColor(Color("rgba(202,138,4,0.08)"))
    }
    /** En attente client : bleu/gris secondaire, texte seul (pas de pill) */
    val rowBusinessStatusEnAttenteClient by style { color(Color("rgba(59,70,212,0.62)")) }

    /** Cercle initiales assigné (row liste tickets) */
    val rowAssigneeCircle by style {
        width(24.px)
        height(24.px)
        borderRadius(50.percent)
        backgroundColor(Color("rgba(102,96,230,0.18)"))
        color(Color("rgba(59,70,212,0.95)"))
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.Center)
        flexShrink(0)
        property("cursor", "default")
    }

    val rowAssigneeCircleText by style {
        fontSize(10.px)
        fontWeight(700)
        property("letter-spacing", "0.02em")
        property("line-height", "1")
    }

    // unread dot moved next to age
    val unreadDotInline by style {
        width(8.px)
        height(8.px)
        borderRadius(99.px)
        // reuse your unread color or set one if needed
        // backgroundColor(Color("#7C7CF8"))
        property("flex", "0 0 auto")
         opacity(0.85)
    }

    // --- Pills typography hierarchy ---
    val metaTextSoft by style {
        fontWeight(500) // less bold
         opacity(0.92)
    }

    val metaTextStrong by style {
        fontWeight(650) // only for missing (strong signal)
    }

    // ---------- L2 État opérationnel (priorité visuelle) ----------
    val opStateLine by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(8.px)
        minWidth(0.px)
        paddingTop(2.px)
    }

    /** Pills état op (Action/En attente/Prêt…) : plus petites, discrètes, moins saturées */
    val opStatePill by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(4.px)
        padding(3.px, 7.px)
        borderRadius(AppStylesTokens.RADIUS_PILL.px)
        fontSize(10.5.px)
        fontWeight(600)
        property("letter-spacing", "-0.004em")
        property("transition", AppStylesTokens.TRANSITION_FAST)
    }

    val opStatePillAction by style {
        backgroundColor(Color("rgba(34,197,94,0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(22,163,74,0.14)"))
        color(Color("rgba(22,163,74,0.88)"))
    }

    val opStatePillWaiting by style {
        backgroundColor(Color("rgba(255, 196, 87, 0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(255, 196, 87, 0.14)"))
        color(Color("rgba(180,83,9,0.82)"))
    }

    val opStatePillReady by style {
        backgroundColor(Color("rgba(59,130,246,0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(37,99,235,0.14)"))
        color(Color("rgba(37,99,235,0.88)"))
    }

    val opStatePillRefund by style {
        backgroundColor(Color("rgba(102,96,230,0.06)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.14)"))
        color(Color("rgba(59,70,212,0.88)"))
    }

    val opStatePillClosed by style {
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color(AppStylesTokens.BORDER))
        color(Color(AppStylesTokens.INK_MUTED))
    }

    // ---------- L2 Badges + Dernier message (même ligne, dernier message à droite) ----------
    val rowBadgeLine by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.Center)
        justifyContent(JustifyContent.SpaceBetween)
        gap(6.px)
        minWidth(0.px)
        paddingTop(2.px)
    }

    val rowBadgeLineLeft by style {
        display(DisplayStyle.Flex)
        flexWrap(FlexWrap.Wrap)
        alignItems(AlignItems.Center)
        gap(6.px)
        minWidth(0.px)
        property("flex", "1 1 0")
    }

    val rowLastMessageRight by style {
        fontSize(11.px)
        fontWeight(500)
        color(Color(AppStylesTokens.INK_MUTED))
        opacity(0.85)
        flexShrink(0)
        property("white-space", "nowrap")
    }

    /** Chip problème : informative, discrète, moins saturée, plus petite */
    val rowBadgeProblem by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(4.px)
        padding(2.px, 5.px)
        borderRadius(10.px)
        fontSize(9.5.px)
        fontWeight(600)
        lineHeight("1")
        backgroundColor(Color("rgba(102,96,230,0.045)"))
        border(1.px, LineStyle.Solid, Color("rgba(102,96,230,0.10)"))
        color(Color("rgba(59,70,212,0.70)"))
    }

    /** Badge "Manque" : informative, discrète, moins saturée, plus petite */
    val rowBadgeMissing by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(4.px)
        padding(2.px, 5.px)
        borderRadius(10.px)
        fontSize(9.5.px)
        fontWeight(600)
        lineHeight("1")
        backgroundColor(Color("rgba(180,83,9,0.045)"))
        border(1.px, LineStyle.Solid, Color("rgba(180,83,9,0.10)"))
        color(Color("rgba(154,70,8,0.70)"))
    }

    /** Pill "Analyse en cours" : extract IA PENDING/RUNNING */
    val rowBadgeAnalyseEnCours by style {
        display(DisplayStyle.Flex)
        alignItems(AlignItems.Center)
        gap(4.px)
        padding(2.px, 5.px)
        borderRadius(10.px)
        fontSize(9.5.px)
        fontWeight(600)
        lineHeight("1")
        backgroundColor(Color("rgba(15,23,42,0.04)"))
        border(1.px, LineStyle.Solid, Color("rgba(15,23,42,0.08)"))
        color(Color("rgba(15,23,42,0.55)"))
    }

}
